import { getHubData } from '@/app/infrastructures/misc/Cookies';
import { QueryParamsEntities4, QueryParamsEntitiesV3 } from './MainApp';
import { ConvertObjectCamelToSnakeCaseV2 } from '@/app/infrastructures/misc/common-library/ConvertObjectCamelToSnakeCase';

export class HangingBkdSummaryConsole {
  lastSync = "";

  totalActivities = 0;
  pendingActivities = 0;
  doneActivities = 0;

  totalSttPos = 0;
  pendingSttPos = 0;
  doneSttPos = 0;
  byStatusPos: ByLabelDetail[] = [];

  totalSttSubKon = 0;
  pendingSttSubKon = 0;
  doneSttSubKon = 0;
  byStatusSubKon: ByLabelDetail[] = []

  totalSttKorporat = 0;
  pendingSttKorporat = 0;
  doneSttKorporat = 0;
  byStatusKorporat: ByLabelDetail[] = [];

  constructor(fields?: Partial<HangingBkdSummaryConsole>) {
    Object.assign(this, fields);
  }
}

export class ByLabelDetail {
  label = "";
  total = 0;
  pending = 0;
  done = 0;

  constructor(fields?: Partial<ByLabelDetail>) {
    Object.assign(this, fields);
  }
}

export class HangingConsoleBkdListRequest {
  search = "";
  days = "";
  existenceStatus = "";
  statusFollowUp = "";
  hubId = "";

  constructor(fields?: Partial<HangingConsoleBkdListRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    this.hubId = getHubData()?.hubId || "0";
    return new QueryParamsEntitiesV3(ConvertObjectCamelToSnakeCaseV2(this))
      .queryString;
  }
}

export class ConfirmHangingBkdConsole {
  hubId = 0;
  activityType = "";
  followUpPartnerType = "";
  followUpPartnerName = "";
  followUpPartnerCode = "";
  username = "";

  constructor(fields?: Partial<ConfirmHangingBkdConsole>) {
    Object.assign(this, fields);

    this.hubId = Number(getHubData()?.hubId || 0);
  }

  toJSON() {
    return JSON.stringify({
      "hub_id": this.hubId,
      "activity_type": this.activityType,
      "follow_up_partner_type": this.followUpPartnerType,
      "follow_up_partner_name": this.followUpPartnerName,
      "follow_up_partner_code": this.followUpPartnerCode,
      username: this.username
    })
  }
}

export class DownloadHangingBkdConsole {
  listStt: string[] = [];
  hubId = 0;

  constructor(fields?: Partial<DownloadHangingBkdConsole>) {
    Object.assign(this, fields);
    this.hubId = getHubData()?.hubId || "0"
  }
}

